<template>
<!--    <div v-loading="!finishGetList">-->
    <div>
        <declaration-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :categoryData="categoryData"
                            :sortData="filterSet.sort" :paginationData="filterSet.page"></declaration-filter-link>
        <declaration-list-link :listLayout="listLayout" :declarationData="List" :categoryData="categoryData" :paginationData="filterSet.page"
                          :sortData="filterSet.sort"></declaration-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>
import DeclarationFilterLink from "@/components/declaration/DeclarationFilterLink";
import DeclarationListLink from "@/components/declaration/DeclarationListLink";
import PaginationLink from "@/components/declaration/PaginationLink";
import declarationUtil from "@/components/declaration/declarationUtil";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";

const {filterConfig} = declarationUtil;
export default {
    name: "DeclarationListComponent",
    mixins: [alertMixins, declarationUtil, filterMixins, listMixins],
    components: {PaginationLink, DeclarationListLink, DeclarationFilterLink},
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setFilterNotParser: this.setFilterNotParser,
            setSort: this.setSort,
            setSortNotParser: this.setSortNotParser,
        }
    },
    props: {
        declarationType: '',
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',
            listApiParamSet: {},
            getFunc: '',
            keyName: '',

            categoryData: [],
            getCategoryFunc: '',
            isCategory: false,
            categoryApiParamSet: {},
        }
    },
    beforeRouterEnter() {},
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        if (this.isGetFirst) {
            this.getList(true);
        } else {
            this.finishGetList = true;
        }
        EventBus.$on('getDeclarationList', this.getList);
    },
    beforeDestroy() {
        EventBus.$off('getDeclarationList');
    },
    destroyed() {},
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initConfig() {
            let config = this.returnDeclarationConfig(this.declarationType);
            this.filterLayout = config.filterLayout;
            this.listLayout = config.listLayout;
            this.paginationLayout = config.paginationLayout;
            this.listApiParamSet = config.listApiParamSet;
            this.getFunc = config.getFunc;
            this.keyName = config.keyName;

            this.isCategory = config.isCategory;
            this.getCategoryFunc = config.getCategoryFunc;
            this.categoryApiParamSet = config.categoryApiParamSet;

            let defaultParams = Object.assign({}, this.listApiParamSet);
            let listOptions = {
                url: this.$api.$declaration[this.getFunc],
                defaultParams: defaultParams,
            }

            if (config.pageRow && config.pageRow !== this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            this.initList('api', listOptions);

            if (this.isCategory) {
                this.getCategory();
            }
        },

        getCategory() {
            let params = {};
            if (!util.isEmpty(this.categoryApiParamSet)) {
                params = this.categoryApiParamSet;
            }

            try {
                this.$api.$declaration[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.categoryData = res.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
